// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"k6-z","disabled":"l6-z","seeAllAnswers":"m6-z"};